import React, {
  useEffect,
  useState,
  Fragment,
  useCallback,
  useMemo,
} from 'react';
import { withStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  AlertBanner,
  CSButton,
  CSTextField,
} from '../primitives';

import Paper from '@material-ui/core/Paper';
import {
  humanReadableNull,
  renderVolumeString,
  renderWeightString,
} from '../DetailsPagesFunctions';
import Layout from '../layout/Layout';
import {
  OutboundLoad,
  Container,
  OutboundLoadLoadStatusEnum,
  StaffPermissionPermissionsEnum,
  DockDoorDetails,
  NestedProcessStepSerializerContainerProcessStepEnum,
} from 'cloudsort-client';

import PaginatedTable, {
  filterObj,
} from '../paginatedTable/PaginatedTable';
import EventsPaginatedTable from '../eventsPaginatedTable/EventsPaginatedTable';
import { AuthRoutes } from '../../interfaces/routes';
import browserHistory from '../../utils/browserHistory';
import { STRING_UNITS_VOLUME } from '../UIStrings';
import { common } from '../../utils/strings';
import detailsPageStyles from '../commonStyles/detailsPage.style';
import selectStyles from '../select/select.styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ConfirmationDialog, {
  Transition,
} from '../confirmationDialog/ConfirmationDialog';
import ErrorHandler from '../../utils/ErrorHandler';
import ProgressIndicator from '../progressIndicator/ProgressIndicator';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import colors from '../../utils/colors';

import {
  GET_COLUMNS_PACKAGES,
  fetch as fetchPackages,
} from '../packages/Packages';
import ContainersService from '../../services/Containers.service';
import configurationUtils from '../../utils/configurationUtils';
import asyncSelectStyles from '../asyncSelect/asyncSelect.styles';
import { noOptionsMessage } from '../../components/asyncSelect/utils';
import debounce from 'lodash/debounce';

// Icons
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import PlanIcon from '../../utils/svgs/PlanIcon';
import CloudDownloadOutlined from '@material-ui/icons/CloudDownloadOutlined';
// Services
import DockDoorService from '../../services/DockDoors.service';
import RoutesService from '../../services/Routes.service';
import OutboundLoadsService from '../../services/OutboundLoads.service';
import PermissionsService from '../../services/Permissions.service';
import EphemeralStateService from '../../services/EphemeralState.service';

//Types
import { AxiosError } from 'axios';
import { Grid, createStyles, GridSize } from '@material-ui/core';
import EventsService from '../../services/Events.service';
import SingleDetail from '../primitives/singleDetail/SingleDetail';
import { Column, TypeAheadItem } from '../../interfaces/components';
import { Helmet } from 'react-helmet';
import { formatContainer } from '../containers/Containers';
import CSSectionTitleSeparator from '../primitives/csSectionTitleSeparator/CSSectionTitleSeparator';
import CSTimeContainer from '../primitives/csTimeContainer/CSTimeContainer';
import CSBreadcrumbs from '../primitives/CSBreadcrumbs/CSBreadcrumbs';
import { CSSingleDetailMonoColumnContainer } from '../primitives/singleDetail/singleDetailMonoColumnContainer';
import { CSSingleDetailMultiColumnContainer } from '../primitives/singleDetail/singleDetailMultiColumnContainer';
import CSAsyncSelect from '../primitives/csAsyncSelect/CSAsyncSelect';
import { CSDualGridContainer } from '../primitives/csDualGridContainer';
import AlertDialog from '../alertDialog/AlertDialog';
import { downloadFile } from '../../utils/fileDownloads';
import { CSDatepicker } from '../primitives/csDatepicker';

export const formatLabel = (str?: string) => {
  if (str === 'N/A') return str;
  const label = str
    ? str
        .replace('_', ' ')
        .split(' ')
        .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
        .join(' ')
    : '';
  return label;
};

const asyncStyles = {
  ...asyncSelectStyles,
  menuPortal: (styles: any) => {
    return {
      ...styles,
      zIndex: 9999,
    };
  },
  input: (styles: any) => {
    return {
      ...styles,
      margin: '0 -3px',
    };
  },
  placeholder: (styles: any) => {
    return {
      ...styles,
      color: colors.lightGray,
      top: '65%',
    };
  },
  control: (styles: any, state: any) => {
    return {
      ...styles,
      backgroundColor: 'transparent !important',
      background: '#F1F1F1',
      padding: '10px 0 0 0',
      boxShadow: 'none !important',
      outline: `none !important`,
      border: 0,
    };
  },
};

interface Props {
  classes: { [key: string]: string };
  match: any;
}

interface PartialContainerData {
  id: number;
  bol: string;
}

const OutboundLoadDetailsComponent: React.FC<Props> = ({
  classes,
  match,
}) => {
  const thisOutboundLoadsId = match.params.id;
  const [outboundLoad, setOutboundLoad] = useState<OutboundLoad>();
  const [containers, setContainers] = useState<Container[]>();
  const [partialContainerData, setPartialContainerData] = useState<
    PartialContainerData[]
  >([]);
  const [containerLastUpdated, setContainerLastUpdated] =
    useState<number>(0);
  const [
    partialContainerLastUpdated,
    setPartialContainerLastUpdated,
  ] = useState<number>(0);
  const [stagedContainersCount, setStagedContainersCount] =
    useState<number>();

  const [showProgress, setShowProgress] = useState<boolean>(false);
  const [showEditDialog, setShowEditDialog] =
    useState<boolean>(false);
  const [showEditBOLDialog, setShowEditBOLDialog] =
    useState<boolean>(false);
  const [showDeleteDialog, setShowDeleteDialog] =
    useState<boolean>(false);
  const [
    showNoReportAvailableDialog,
    setShowNoReportAvailableDialog,
  ] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  //Edit form fields
  const [route, setRoute] = useState<TypeAheadItem>();
  const [capacity, setCapacity] = useState<string | number>();
  const [loadName, setLoadName] = useState<string>();
  const [loadTime, setLoadTime] = useState<Date>();
  const [dockDoor, setDockDoor] = useState<TypeAheadItem>();
  const [trailerId, setTrailerId] = useState<string>();
  const [bol, setBol] = useState<string>();
  const [loadStatus, setLoadStatus] =
    useState<OutboundLoadLoadStatusEnum>();

  //TODO: Update this when CCC is merged
  const isBOLActive = true;
  const isBOLInherit = false;

  const trailerIdIsActive = useMemo(() => {
    return EphemeralStateService.getMyStationConfiguratation().GENERAL
      ?.BEHAVIORS?.LOAD_OPS?.trailer_id_active;
  }, []);

  const trailerIdLabel = useMemo(() => {
    return configurationUtils.getPropertylabel(
      'OUTBOUND_LOAD',
      'trailer_id',
    );
  }, []);

  const saveReportsArchive = useCallback(async () => {
    try {
      setShowProgress(true);
      downloadFile(
        await OutboundLoadsService.getReports(thisOutboundLoadsId),
      );
    } catch (err) {
      if ((err as AxiosError)?.response?.status === 404) {
        setShowNoReportAvailableDialog(true);
      } else {
        handleError(err as AxiosError);
      }
    } finally {
      setShowProgress(false);
    }
  }, [thisOutboundLoadsId]);

  const downloadCSV = useCallback(async () => {
    setShowProgress(true);
    try {
      downloadFile(
        await OutboundLoadsService.getCSVExport({
          id: thisOutboundLoadsId,
          //TODO: Check with JOAO about date requirements here for single item downloads
          fromDate: new Date().toISOString(),
          toDate: new Date().toISOString(),
        }),
        `outbound_load_export_for_id_${thisOutboundLoadsId}.csv`,
      );
    } catch (e) {
      handleError(e as AxiosError);
    } finally {
      setShowProgress(false);
    }
  }, [thisOutboundLoadsId]);

  // Get labels on each render cycle
  const COLUMNS_CONTAINERS: Column[] = [
    {
      id: 'id',
      label: 'ID',
      width: 50,
      align: 'left',
    },
    {
      id: 'critical_activity_time',
      label: 'Critical Time',
      align: 'center',
      width: 'left',
    },
    {
      id: 'tracking_number',
      label: 'Tracking Number',
      width: 'auto',
      align: 'center',
    },
    {
      id: 'type',
      label: 'Type',
      width: 200,
      align: 'left',
      useCustomComponent: true,
    },
    {
      id: 'display_status',
      label: 'Status',
      width: 'auto',
      align: 'left',
      useCustomComponent: true,
    },
    {
      id: 'dwell_time',
      label: 'Dwell time',
      align: 'center',
      width: 'auto',
    },
    {
      id: 'package_count',
      label: configurationUtils.getPageTitle(false, 'PACKAGE'),
      width: 'auto',
      align: 'left',
    },
    {
      id: 'volume',
      label: 'Volume',
      width: 'auto',
      align: 'left',
    },
    {
      id: 'container_type',
      label: `Type of ${configurationUtils.getModuleLabel(
        true,
        'CONTAINER',
      )}`,
      width: 'auto',
      align: 'left',
    },
    {
      id: 'location',
      label: 'Location',
      align: 'center',
      width: 'left',
    },
  ];

  if (isBOLActive) {
    COLUMNS_CONTAINERS.push({
      id: 'bol',
      label: 'BOL',
      align: 'center',
      width: 'left',
    });
  }

  const inputLabelProps = {
    shrink: true,
    className: classes.selectLabel,
  };

  const inputProps = {
    disableUnderline: true,
    className: classes.inputPadding,
  };

  const packagesTableColumns = useMemo(() => {
    return GET_COLUMNS_PACKAGES().map((column) => {
      if (column.id === 'outbound_load_name') {
        // remove link from outbound_load_name because is the same as the current view
        column.link = undefined;
      }
      return column;
    });
  }, []);

  const editClickHandler = () => {
    if (outboundLoad?.dockdoor) {
      setDockDoor({
        value: outboundLoad.dockdoor.toString(),
        label: outboundLoad.dockdoor_name || '',
      });
    } else {
      setDockDoor(undefined);
    }

    if (outboundLoad?.load_time)
      setLoadTime(new Date(outboundLoad?.load_time));

    if (outboundLoad?.route) {
      setRoute({
        value: outboundLoad.route.toString(),
        label: outboundLoad.route_name || '',
      });
    }
    if (outboundLoad?.capacity) setCapacity(outboundLoad?.capacity);

    if (outboundLoad?.name) setLoadName(outboundLoad?.name);

    if (outboundLoad?.bol) setBol(outboundLoad?.bol);

    setShowEditDialog(true);
  };

  const deleteLoadHandler = async () => {
    setShowProgress(true);
    try {
      if (thisOutboundLoadsId) {
        await OutboundLoadsService.delete(thisOutboundLoadsId);
        browserHistory.push(AuthRoutes.OUTBOUND_LOAD);
      }
    } catch (e) {
      handleError(e as AxiosError);
      setShowProgress(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadDDOptions = useCallback(
    debounce((inputValue: string, callback: any) => {
      DockDoorService.search(inputValue)
        .then((data) => {
          callback(
            data.data.results.map((dataEl: DockDoorDetails) => {
              return {
                value: dataEl.id,
                label: dataEl.name,
              };
            }),
          );
        })
        .catch((e) => {
          handleError(e as AxiosError);
        });
    }, 500),
    [],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadRoutesOptions = useCallback(
    debounce((inputValue: string, callback: any) => {
      RoutesService.getAll({ search: inputValue })
        .then((data) => {
          callback(
            data.data.results.map((dataEl: DockDoorDetails) => {
              return {
                value: dataEl.id,
                label: dataEl.name,
              };
            }),
          );
        })
        .catch((e) => {
          handleError(e as AxiosError);
        });
    }, 500),
    [],
  );

  const checkIfChange = (partialValue: any, dataValue: any) => {
    if (partialValue instanceof Date && dataValue instanceof Date) {
      if (partialValue.toString() !== dataValue.toString()) {
        return partialValue;
      }
    } else if (partialValue !== dataValue) {
      return partialValue;
    }
    return undefined;
  };

  const saveEditHandler = async () => {
    setShowProgress(true);
    try {
      if (route && loadTime) {
        await OutboundLoadsService.update(
          thisOutboundLoadsId,
          checkIfChange(Number(route.value!), outboundLoad?.route),
          checkIfChange(loadTime, new Date(outboundLoad?.load_time!)),
          checkIfChange(
            Number(dockDoor?.value!),
            outboundLoad?.dockdoor,
          ),
          checkIfChange(loadStatus, outboundLoad?.load_status),
          checkIfChange(Number(capacity), outboundLoad?.capacity),
          checkIfChange(
            trailerId !== '' ? trailerId : null,
            outboundLoad?.trailer_id,
          ),
          checkIfChange(loadName, outboundLoad?.name),
          checkIfChange(bol, outboundLoad?.bol),
        );
        setShowEditDialog(false);
        await fetchAll();
      }
    } catch (e) {
      handleError(e as AxiosError);
      setShowProgress(false);
    }
  };

  //Fetch events

  const fetchEvents = async (
    pageIndex: number,
    rowsPerPage: number,
  ) => {
    return EventsService.getAll({
      page: pageIndex,
      outboundLoad: thisOutboundLoadsId,
      pageSize: rowsPerPage,
    });
  };

  const handleError = async (e: AxiosError) => {
    setError(await ErrorHandler.getLabel(e as AxiosError));
  };

  const fetchOutboundLoadDetails = async () => {
    return OutboundLoadsService.getById(thisOutboundLoadsId);
  };

  const fetchContainers = async (
    pageIndex: number,
    rowsPerPage: number,
  ) => {
    const res = await ContainersService.getAll({
      page: pageIndex,
      outboundLoad: thisOutboundLoadsId,
      pageSize: rowsPerPage,
      fromDate: '',
      toDate: '',
    });

    setContainers(res.data.results);

    res.data.results.forEach((container: any) => {
      formatContainer(container);
    });

    return res;
  };

  const fetchOutboundLoadDetailsData = async () => {
    const { data } = await fetchOutboundLoadDetails();
    setOutboundLoad(data);
    setLoadStatus(data.load_status);
    setCapacity(data.capacity?.toString());
    setTrailerId(data.trailer_id || '');
    if (data.route) {
      setRoute({
        value: data.route.toString(),
        label: data.route_name || '',
      });
    }

    if (data.load_status !== OutboundLoadLoadStatusEnum.DISPATCHED) {
      const res = await ContainersService.getAll({
        page: 1,
        targetOutboundLoad: thisOutboundLoadsId,
        pageSize: 10,
        fromDate: '',
        toDate: '',
        processStep: [
          NestedProcessStepSerializerContainerProcessStepEnum.STAGED,
        ],
        excludeParentContainers: true,
      });

      setStagedContainersCount(res.data.count);
    }

    setContainerLastUpdated(Date.now());
  };

  const fetchAll = async () => {
    setShowProgress(true);
    try {
      await fetchOutboundLoadDetailsData();
    } catch (e) {
      handleError(e as AxiosError);
    }
    setShowProgress(false);
  };

  const renderError = () => {
    return (
      error && (
        <AlertBanner
          data-testid='outbound-loads-error-banner'
          className={classes.banner}
          severity='error'
          alertTitle={'Error'}
          alertMsg={error}
        />
      )
    );
  };

  const getDialogTitle = () => `Edit ${pageTitle}`;

  const updateContainerData = async (
    partialData: PartialContainerData[],
  ) => {
    setShowProgress(true);
    try {
      for (const dataEl of partialData) {
        await ContainersService.update(dataEl.id, {
          bol: dataEl.bol,
        });
      }
      setContainerLastUpdated(Date.now());
      setShowEditBOLDialog(false);
    } catch (e) {
      handleError(e as AxiosError);
    }
    setShowProgress(false);
  };

  const renderEditBOLDialog = () => {
    const tableHeaders = [
      'Container ID',
      'Status',
      'Type',
      'Nr of Packages',
      'BOL',
    ];

    return (
      <Dialog
        classes={{ paperScrollPaper: classes.dialogRoot }}
        open={showEditBOLDialog}
        TransitionComponent={Transition}
        style={{ minWidth: 650 }}
        maxWidth='xl'
        onClose={() => {
          onAfterDialogClose();
        }}
      >
        {renderError()}
        <DialogTitle>
          {getDialogTitle()}
          <br />
          <br />
          Edit Containers BOLs
        </DialogTitle>

        <DialogContent
          className={classes.dialogRoot}
          style={{ overflow: 'hidden', minWidth: 650, padding: 0 }}
        >
          <Box mt={1}>
            <TableContainer
              component={Paper}
              key={partialContainerLastUpdated}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    {tableHeaders.map((header) => {
                      return (
                        <TableCell
                          key={header}
                          className={classes.editBolTableHeader}
                        >
                          {header}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {containers?.map((container: Container) => (
                    <TableRow key={container.id}>
                      <TableCell>{container.id}</TableCell>
                      <TableCell>
                        {formatLabel(container.container_status)}
                      </TableCell>
                      <TableCell>
                        {formatLabel(container.container_type)}
                      </TableCell>
                      <TableCell>{container.package_count}</TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <FormControl
                          className={classes.formControl}
                          style={{
                            maxWidth: 200,
                            minWidth: 100,
                          }}
                        >
                          <TextField
                            defaultValue={container.bol}
                            onChange={(e) => {
                              const c = partialContainerData.find(
                                (c) => c.id === container.id,
                              );
                              const value = e.target.value;
                              if (c) {
                                c.bol = value;
                                setPartialContainerData([
                                  ...partialContainerData,
                                ]);
                              } else {
                                setPartialContainerData([
                                  ...partialContainerData,
                                  { id: container.id!, bol: value },
                                ]);
                              }
                            }}
                            InputProps={inputProps}
                            inputProps={{ min: '0' }}
                          />
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>

        <DialogActions style={{ justifyContent: 'space-between' }}>
          <Box>
            <CSButton
              variant='outlined'
              color='secondary'
              data-testid={'outbound-loads-BOL-dialog-reset-all'}
              onClick={() => {
                setPartialContainerData([]);
                setPartialContainerLastUpdated(Date.now());
              }}
            >
              Reset All
            </CSButton>
          </Box>
          <Box>
            <CSButton
              variant='outlined'
              color='secondary'
              data-testid={'outbound-loads-BOL-dialog-cancel'}
              onClick={() => {
                onAfterDialogClose();
              }}
            >
              Cancel
            </CSButton>
            <CSButton
              variant='contained'
              color='secondary'
              onClick={() => {
                updateContainerData(partialContainerData);
              }}
              data-testid={'outbound-loads-BOL-dialog-save'}
              disabled={!route}
            >
              Save
            </CSButton>
          </Box>
        </DialogActions>
      </Dialog>
    );
  };

  const renderDialog = () => {
    const hasCustomBol =
      !!bol && containers?.some((container) => container.bol !== bol);
    const showSomeContainersLabel =
      !!outboundLoad?.bol && hasCustomBol && !isBOLInherit;

    const getMinHeight = () => {
      if (isBOLActive) {
        if (showSomeContainersLabel) {
          return 290;
        } else {
          return 250;
        }
      }
      return 200;
    };

    return (
      <Dialog
        classes={{
          paperScrollPaper: classes.dialogRoot,
          paper: classes.dialogPaper,
        }}
        maxWidth={false}
        open={showEditDialog}
        TransitionComponent={Transition}
        onClose={() => {
          onAfterDialogClose();
        }}
      >
        {renderError()}
        <DialogTitle
          className={classes.dialogTitle}
          disableTypography
        >
          <Grid container justifyContent='center'>
            <Grid item container xs={12} justifyContent='center'>
              <div className={classes.dialogIconContainer}>
                <EditIcon />
              </div>
            </Grid>
            <Grid item container xs={12} justifyContent='center'>
              <Typography variant='h5' component='h2'>
                Edit Outbound Load
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent
          className={classes.dialogRoot}
          style={{ overflow: 'hidden', minHeight: getMinHeight() }}
        >
          <CSDualGridContainer
            childrenColumnConfiguration={{ 0: 12 }}
          >
            <CSAsyncSelect<TypeAheadItem>
              data-testid='select-route'
              label={`Select ${configurationUtils.getPageTitle(
                true,
                'ROUTE',
              )}`}
              isClearable
              cacheOptions
              loadOptions={loadRoutesOptions}
              onChange={(option) => {
                setRoute(option as TypeAheadItem);
              }}
              isDisabled={!!error}
              placeholder='Start Typing...'
              value={route}
              containerSize='fullHorizontal'
              menuPortalTarget={document.body}
              noOptionsMessage={noOptionsMessage}
            />
            {trailerIdIsActive && (
              <CSTextField
                label={trailerIdLabel}
                type='text'
                value={trailerId || ''}
                onChange={(e) => {
                  setTrailerId(e.target.value);
                }}
                onClear={() => setTrailerId('')}
                InputLabelProps={inputLabelProps}
                data-testid='trailer-id'
                containerSize='fullHorizontal'
              />
            )}
            <CSDatepicker
              id='date-picker-edit-load'
              data-testid='select-dispatch-time'
              selectionType='datetime'
              label='Dispatch time'
              initialValue={new Date(loadTime ?? '')}
              onAcceptSelection={(date) => {
                date
                  ? setLoadTime(date as Date)
                  : setLoadTime(undefined);
              }}
            />
            <CSTextField
              label='Capacity'
              type='number'
              data-testid='load-capacity'
              value={capacity?.toString() || ''}
              onChange={(e) => {
                setCapacity(e.target.value);
              }}
              hideClear
              InputLabelProps={inputLabelProps}
              endAdornment={
                <div className={classes.unitAdornmentBox}>
                  {STRING_UNITS_VOLUME}
                </div>
              }
              inputProps={{ min: '0' }}
              containerSize='fullHorizontal'
            />
            <CSTextField
              data-testid='load-name'
              label='Name'
              type='text'
              value={loadName || ''}
              onChange={(e) => {
                setLoadName(e.target.value);
              }}
              onBlur={(e) => {
                if (e.target.value.trim() === '')
                  setLoadName(
                    route?.label ? 'OL-' + route?.label : '',
                  );
              }}
              onClear={() => setLoadName('')}
              InputLabelProps={inputLabelProps}
              containerSize='fullHorizontal'
            />

            <CSAsyncSelect<TypeAheadItem>
              label={
                configurationUtils.isModuleActive('DOCK_DOOR')
                  ? configurationUtils.getPageTitle(true, 'DOCK_DOOR')
                  : 'Destination'
              }
              containerSize='fullHorizontal'
              isClearable
              cacheOptions
              styles={asyncStyles}
              loadOptions={loadDDOptions}
              onChange={(option) => {
                setDockDoor(option as TypeAheadItem);
              }}
              isDisabled={!!error}
              placeholder={'Start Typing...'}
              value={dockDoor}
              menuPortalTarget={document.body}
              noOptionsMessage={noOptionsMessage}
            />

            {isBOLActive && (
              <CSTextField
                label='BOL'
                data-testid='edit-load-bol'
                value={bol || ''}
                onChange={(e) => {
                  setBol(e.target.value);
                }}
                onClear={() => setBol('')}
                containerSize='fullHorizontal'
                InputLabelProps={inputLabelProps}
                customContent={
                  showSomeContainersLabel && (
                    <Box fontSize={12}>
                      <Box mt={2}>
                        Some containers are already with BOL set up
                      </Box>
                      <Box
                        mt={0.5}
                        className={classes.bolLink}
                        role='button'
                        onClick={() => {
                          saveEditHandler();
                          setShowEditDialog(false);
                          setShowEditBOLDialog(true);
                        }}
                      >
                        Save and Set BOL’s at containers level
                      </Box>
                    </Box>
                  )
                }
              />
            )}
          </CSDualGridContainer>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <CSButton
            variant='outlined'
            color='secondary'
            data-testid={'outbound-loads-dialog-cancel'}
            onClick={() => {
              onAfterDialogClose();
            }}
          >
            Cancel
          </CSButton>
          <CSButton
            variant='contained'
            color='secondary'
            onClick={() => {
              saveEditHandler();
            }}
            data-testid={'outbound-loads-dialog-save'}
            disabled={!route}
          >
            Save
          </CSButton>
        </DialogActions>
      </Dialog>
    );
  };

  const onAfterDialogClose = () => {
    setShowEditBOLDialog(false);
    setShowEditDialog(false);
    setLoadTime(undefined);
    setDockDoor(undefined);
    setRoute(undefined);
    setCapacity(undefined);
    setError(undefined);
  };

  useEffect(() => {
    PermissionsService.redirectIfNoPermission(
      StaffPermissionPermissionsEnum.OUTBOUNDLOAD_READ,
    );

    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const commonColumnSingleDetail = {
    labelColumns: 5 as GridSize,
    valueColumns: 7 as GridSize,
  };

  const pageTitle = `${configurationUtils.getPageTitle(
    true,
    'OUTBOUND_LOAD',
  )} ${outboundLoad?.name || outboundLoad?.id || ''}`;

  return (
    <>
      <Helmet>
        <title>{`CloudSort - ${pageTitle} `}</title>
      </Helmet>
      <Layout navCurrent='OUTBOUND_LOAD'>
        {showProgress && <ProgressIndicator />}
        {renderDialog()}
        {renderEditBOLDialog()}
        <ConfirmationDialog
          dataTestIdPrefix={'load-details-delete-dialog'}
          title={`Delete ${configurationUtils.getPageTitle(
            true,
            'OUTBOUND_LOAD',
          )}`}
          msg={`Are you sure you want to delete ${configurationUtils.getPageTitle(
            true,
            'OUTBOUND_LOAD',
          )} ${outboundLoad?.name || thisOutboundLoadsId}?`}
          primaryActionLabel={'Delete'}
          onPrimaryAction={deleteLoadHandler}
          cancelLabel={'Cancel'}
          onCancel={() => {
            setShowDeleteDialog(false);
          }}
          isOpen={showDeleteDialog}
        />
        <AlertDialog
          title={`No files available yet`}
          msg={`No files available yet, please allow for a few minutes of processing time.`}
          onPrimaryAction={() => {
            setShowNoReportAvailableDialog(false);
          }}
          isOpen={showNoReportAvailableDialog}
        />
        <div
          className={classes.detailViewoutboundLoad}
          data-testid='load-details-view'
        >
          {renderError()}
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Box mb={5}>
                <CSBreadcrumbs
                  breadcrumbs={[
                    {
                      label: 'Outbound Loads',
                      link:
                        AuthRoutes.OUTBOUND_LOAD +
                        '?stationId=' +
                        // TODO: outboundloads does not include the station data
                        // Check CLOUD-3077
                        EphemeralStateService.getMyStationId(),
                    },
                    {
                      label: `${pageTitle}`,
                      selected: true,
                    },
                  ]}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            alignItems='center'
            style={{ marginBottom: 8 }}
          >
            <Grid
              item
              xs={12}
              sm={
                outboundLoad?.load_status ===
                OutboundLoadLoadStatusEnum.DISPATCHED
                  ? 4
                  : 6
              }
            >
              <Typography variant='h3' component='h2'>
                {pageTitle}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={
                outboundLoad?.load_status ===
                OutboundLoadLoadStatusEnum.DISPATCHED
                  ? 8
                  : 6
              }
              style={{ textAlign: 'right' }}
            >
              {PermissionsService.hasPermission(
                StaffPermissionPermissionsEnum.OUTBOUNDLOAD_WRITE,
              ) && (
                <>
                  <CSButton
                    color='secondary'
                    variant='outlined'
                    className={classes.marginButton}
                    data-testid={'load-details-edit-button'}
                    fullWidth={false}
                    disabled={!outboundLoad}
                    onClick={(e) => {
                      e.preventDefault();
                      editClickHandler();
                    }}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </CSButton>
                  <CSButton
                    color='secondary'
                    variant='outlined'
                    className={classes.marginButton}
                    data-testid={'load-details-delete-button'}
                    fullWidth={false}
                    disabled={!outboundLoad}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowDeleteDialog(true);
                    }}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </CSButton>
                </>
              )}
              {outboundLoad?.load_status ===
                OutboundLoadLoadStatusEnum.DISPATCHED && (
                <>
                  <CSButton
                    className={classes.marginButton}
                    fullWidth={false}
                    variant='contained'
                    color='primary'
                    disabled={!outboundLoad}
                    onClick={downloadCSV}
                    startIcon={<CloudDownloadOutlined />}
                  >
                    Download CSV
                  </CSButton>
                  <CSButton
                    className={classes.marginButton}
                    fullWidth={false}
                    variant='contained'
                    color='primary'
                    disabled={!outboundLoad}
                    onClick={saveReportsArchive}
                    startIcon={
                      <PlanIcon className={classes.planIcon} />
                    }
                  >
                    Download Report
                  </CSButton>
                </>
              )}
            </Grid>
            <Grid item xs={12}>
              <CSSectionTitleSeparator topMargin={5} />
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginBottom: 8 }}>
            <Grid item xs={12} sm={6} md={8}>
              <CSSingleDetailMultiColumnContainer
                elements={[
                  <SingleDetail
                    key='status'
                    inline={true}
                    label='Status'
                    value={
                      outboundLoad?.load_status
                        ? formatLabel(outboundLoad.load_status)
                        : common.emptyValue
                    }
                  />,
                  trailerIdIsActive && (
                    <SingleDetail
                      key={trailerIdLabel}
                      inline={true}
                      label={trailerIdLabel}
                      value={
                        outboundLoad?.trailer_id || common.emptyValue
                      }
                    />
                  ),
                  isBOLActive ? (
                    <SingleDetail
                      key='BOL'
                      inline={true}
                      label={'BOL'}
                      value={outboundLoad?.bol || common.emptyValue}
                    />
                  ) : undefined,
                  <SingleDetail
                    key={configurationUtils.getPageTitle(
                      true,
                      'DOCK_DOOR',
                    )}
                    inline={true}
                    label={configurationUtils.getPageTitle(
                      true,
                      'DOCK_DOOR',
                    )}
                    value={
                      outboundLoad?.dockdoor_name || common.emptyValue
                    }
                  />,
                  <SingleDetail
                    key={configurationUtils.getPageTitle(
                      true,
                      'ROUTE',
                    )}
                    inline={true}
                    label={configurationUtils.getPageTitle(
                      true,
                      'ROUTE',
                    )}
                    value={
                      outboundLoad?.route_name || common.emptyValue
                    }
                  />,
                  <SingleDetail
                    key='AWB'
                    inline={true}
                    label='AWB'
                    value={outboundLoad?.awb || common.emptyValue}
                  />,
                ]}
                data-testid=''
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CSTimeContainer
                elements={[
                  {
                    title: 'Target Load Time',
                    titleTestId: 'Target Load Time:label',
                    content: outboundLoad?.load_time
                      ? new Date(
                          outboundLoad?.load_time,
                        ).toLocaleString()
                      : common.emptyValue,
                    contentTestId: 'Target Load Time:value',
                  },
                ]}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginBottom: 8 }}>
            <Grid item xs={12} sm={6}>
              <Paper
                className={classes.paper}
                style={{ marginRight: 18, padding: 16 }}
              >
                <CSSingleDetailMonoColumnContainer
                  header={`${configurationUtils.getPageTitle(
                    true,
                    'OUTBOUND_LOAD',
                  )} Details`}
                  elements={[
                    <SingleDetail
                      key={`Loaded ${configurationUtils.getPageTitle(
                        false,
                        'CONTAINER',
                      )}`}
                      label={`Loaded ${configurationUtils.getPageTitle(
                        false,
                        'CONTAINER',
                      )}`}
                      value={humanReadableNull(
                        outboundLoad?.containers_loaded_count,
                      )}
                      {...commonColumnSingleDetail}
                    />,
                    outboundLoad?.load_status !==
                    OutboundLoadLoadStatusEnum.DISPATCHED ? (
                      <SingleDetail
                        key={`Staged ${configurationUtils.getPageTitle(
                          false,
                          'CONTAINER',
                        )}`}
                        label={`Staged ${configurationUtils.getPageTitle(
                          false,
                          'CONTAINER',
                        )}`}
                        value={humanReadableNull(
                          stagedContainersCount,
                        )}
                        {...commonColumnSingleDetail}
                      />
                    ) : undefined,
                    <SingleDetail
                      key={`Loaded ${configurationUtils.getPageTitle(
                        false,
                        'PACKAGE',
                      )}`}
                      label={`Loaded ${configurationUtils.getPageTitle(
                        false,
                        'PACKAGE',
                      )}`}
                      value={humanReadableNull(
                        outboundLoad?.packages_loaded_count,
                      )}
                      {...commonColumnSingleDetail}
                    />,
                  ]}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Paper
                className={classes.paper}
                style={{ padding: 16 }}
              >
                <CSSingleDetailMonoColumnContainer
                  header={`${configurationUtils.getPageTitle(
                    true,
                    'OUTBOUND_LOAD',
                  )} Details`}
                  elements={[
                    <SingleDetail
                      key={`${configurationUtils.getPageTitle(
                        true,
                        'OUTBOUND_LOAD',
                      )} Capacity`}
                      label={`${configurationUtils.getPageTitle(
                        true,
                        'OUTBOUND_LOAD',
                      )} Capacity`}
                      value={renderVolumeString(
                        outboundLoad?.capacity,
                      )}
                      {...commonColumnSingleDetail}
                    />,
                    <SingleDetail
                      key='Current Volume'
                      label='Current Volume'
                      value={renderVolumeString(outboundLoad?.volume)}
                      {...commonColumnSingleDetail}
                    />,
                    <SingleDetail
                      key='Current Weight'
                      label='Current Weight'
                      value={renderWeightString(outboundLoad?.weight)}
                      {...commonColumnSingleDetail}
                    />,
                  ]}
                />
              </Paper>
            </Grid>
          </Grid>

          <EventsPaginatedTable
            dataTestIdPrefix={'load-details-events'}
            fetch={fetchEvents}
            sortableBy={['timestamp', 'area_name']}
          />
          <br />
          {configurationUtils.isModuleActive('PACKAGE') &&
            PermissionsService.hasPermission(
              StaffPermissionPermissionsEnum.PACKAGE_READ,
            ) && (
              <PaginatedTable
                disableUpdateQueryStringUrl
                title={configurationUtils.getPageTitle(
                  false,
                  'PACKAGE',
                )}
                columns={packagesTableColumns}
                dataTestIdPrefix={'load-details-packages'}
                fetch={(
                  pageIndex: number,
                  rowsPerPage: number,
                  filterOptions?: filterObj[],
                  filterByString?: string,
                  sortedBy?: string,
                ) => {
                  return fetchPackages(
                    pageIndex,
                    rowsPerPage,
                    {},
                    sortedBy,
                    {
                      outboundLoad: [thisOutboundLoadsId],
                      outboundLoadDirect: true,
                      fromDate: '',
                      toDate: '',
                    } as any,
                  );
                }}
                rowsLoadDetailPages={true}
                detailsPageBasePath={AuthRoutes.PACKAGE}
              />
            )}

          {configurationUtils.isModuleActive('CONTAINER') &&
            PermissionsService.hasPermission(
              StaffPermissionPermissionsEnum.CONTAINER_READ,
            ) && (
              <Fragment>
                <br />
                <PaginatedTable
                  disableUpdateQueryStringUrl
                  key={'table' + containerLastUpdated}
                  title={configurationUtils.getPageTitle(
                    false,
                    'CONTAINER',
                  )}
                  columns={COLUMNS_CONTAINERS}
                  dataTestIdPrefix={'load-details-containers'}
                  fetch={fetchContainers}
                  rowsLoadDetailPages={true}
                  detailsPageBasePath={AuthRoutes.CONTAINER}
                />
              </Fragment>
            )}
        </div>
      </Layout>
    </>
  );
};

export default withStyles(
  createStyles((theme: Theme) => ({
    ...detailsPageStyles,
    ...selectStyles,
    editBlock: {
      margin: theme.spacing(4, 0),
      padding: '0 2em 0 2em',
    },
    detailViewoutboundLoad: {
      padding: '0 2em 0 2em',
    },
    numberAdornment: {
      height: '100%',
    },
    padding2em: {
      padding: '2em',
    },
    flexRowEvenSpread: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
    },
    half: {
      width: '50%',
      borderRight: '1px solid #fafafa',
    },
    outboundLoadDetails: {
      display: 'flex',
      flexDirection: 'row',
    },
    tableHeader: {
      background: '#fafafa',
    },
    asyncPadding: {
      '&>div': {
        padding: '6px 0',
      },
    },
    marginButton: {
      margin: '0 0 0 8px',
      [theme.breakpoints.down('md')]: {
        margin: '2px',
      },
    },
    banner: {
      width: '100%',
      borderRadius: 4,
      margin: '10px 0',
    },
    bolLink: {
      color: colors.darkGold,
      cursor: 'pointer',
    },
    editBolTableHeader: {
      color: colors.lightGray,
      width: '25%',
    },
    inputPadding: {
      paddingLeft: '5px',
      paddingRigth: '5px',
    },
    editRow: {
      '& td': {
        height: 70,
      },
      '& th': {
        height: 70,
      },
    },
    autoCompleteComponent: {
      '& .MuiFormControl-root': {
        width: '100%',
      },
      '& .MuiInputLabel-formControl': {
        transform: 'translate(5px, 17px) scale(1)',
      },
      '& .MuiInputLabel-shrink': {
        top: '5px',
        left: '5px',
        transform: 'translate(0, 1.5px) scale(0.75)',
      },
      '& .MuiInputBase-root': {
        paddingLeft: '5px',
      },
      '& .MuiInput-underline': {
        '&::before': {
          display: 'none',
        },
        '&::after': {
          display: 'none',
        },
      },
    },
    datePicker: {
      width: '100%',
      height: 48,
      position: 'relative',
      cursor: 'pointer',
      '& .MuiTextField-root': {
        position: 'absolute',
        width: '100%',
        top: 3,
        left: 5,
      },
    },
    dialogTitle: {
      padding: 24,
    },
    dialogPaper: {
      width: 493,
      maxHeight: '100%',
    },
    dialogActions: {
      padding: '16px 23px 25px 8px',
    },
    datePickerIcon: {
      position: 'absolute',
      width: 24,
      height: 24,
      top: 13,
      right: 12,
    },
    dialogIconContainer: {
      color: theme.palette.primary.main,
    },
    loadPercentageoutboundLoad: {
      padding: '20px',
    },
    loadBarOuter: {
      width: '100%',
      background: colors.lightGold,
      borderRadius: '5px',
    },
    loadBarInner: {
      width: 0,
      height: '10px',
      background: colors.darkGold,
      borderRadius: '5px',
    },
    loadBarLabel: {
      margin: '10px 0 0 0',
      fontSize: '30px',
      lineHeight: 1,
    },
    unitAdornmentBox: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '2px',
      height: '24px',
      width: '14px',
    },
    planIcon: {
      '&> path': {
        fill: theme.palette.common.white,
      },
    },
  })),
)(OutboundLoadDetailsComponent);
